// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://thoxuskzoiecvvfvfoiv.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRob3h1c2t6b2llY3Z2ZnZmb2l2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjI1MDU0NTgsImV4cCI6MjA3ODA4MTQ1OH0.w3pBoWFrd-38GuKnJ9kO3HDunqGnMRhxaEQB3p8u1OE';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
